import React from 'react';

export type ButtonVariant = 'default' | 'primary' | 'secondary' | 'danger' | 'github';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: ButtonVariant;
    block?: boolean;
    leftIcon?: React.ReactNode;
    className?: string;
}

export default function Button({
    variant = 'default',
    block = false,
    leftIcon,
    className = '',
    children,
    ...rest
}: ButtonProps) {
    const variantClass =
        variant === 'primary'
            ? 'btn-primary'
            : variant === 'secondary'
                ? 'btn-secondary'
                : variant === 'danger'
                    ? 'btn-danger'
                    : variant === 'github'
                        ? 'btn-github'
                        : 'modal-btn-default';
    const blockClass = block ? 'btn-block' : '';
    const classes = ['btn', variantClass, blockClass, className].filter(Boolean).join(' ');

    return (
        <button {...rest} className={classes}>
            {leftIcon && <span className="btn__left-icon">{leftIcon}</span>}
            {children}
        </button>
    );
}
